import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
const Form = React.forwardRef(({ className, ...props }, ref) => {
    return (_jsx("form", { ref: ref, className: cn('space-y-6', className), ...props }));
});
Form.displayName = 'Form';
export { Form };
